import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-wijk-zwemmen',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconWijkZwemmen {

  render() {
    return (
      <svg data-name="Layer 1" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M9.07 8.58c0-.55.45-1 1-1h6.54c1.91 0 3.62 1.06 4.48 2.76l3.9 7.79c.25.49.05 1.09-.45 1.34a1.007 1.007 0 0 1-1.35-.44l-2.99-5.97-9.64 5.39c-.16.09-.33.13-.5.13a.995.995 0 0 1-.5-1.86l9.72-5.47a2.992 2.992 0 0 0-2.69-1.66h-6.54c-.55 0-1-.45-1-1Zm15.01 3.5c0-2.48 2.02-4.5 4.51-4.5s4.51 2.02 4.51 4.5-2.02 4.5-4.51 4.5-4.51-2.02-4.51-4.5m2 0c0 1.38 1.12 2.5 2.51 2.5s2.51-1.12 2.51-2.5-1.12-2.5-2.51-2.5-2.51 1.12-2.51 2.5M1.55 22.4c1.64-.9 3.83-.72 5.22.43 2.36 1.97 6.06 1.97 8.42 0 1.59-1.33 4.26-1.33 5.85 0 1.18.99 2.69 1.48 4.21 1.48s3.03-.49 4.21-1.48c1.35-1.13 3.52-1.33 5.14-.47.49.26 1.1.07 1.35-.42a.996.996 0 0 0-.42-1.35c-2.36-1.24-5.38-.95-7.36.71-1.59 1.33-4.26 1.33-5.85 0-2.36-1.97-6.06-1.97-8.42 0-1.59 1.33-4.26 1.33-5.85 0-2.02-1.69-5.1-1.96-7.47-.65-.48.27-.66.88-.39 1.36.27.48.88.66 1.36.39m33.98 3.46c-2.36-1.24-5.38-.95-7.36.71-1.59 1.33-4.26 1.33-5.85 0-2.36-1.97-6.06-1.97-8.42 0-1.59 1.33-4.26 1.33-5.85 0-2.02-1.69-5.1-1.96-7.47-.65-.48.27-.66.88-.39 1.36.27.48.88.66 1.36.39 1.64-.9 3.83-.72 5.22.43 2.36 1.97 6.06 1.97 8.42 0 1.59-1.33 4.26-1.33 5.85 0 1.18.99 2.69 1.48 4.21 1.48s3.03-.49 4.21-1.48c1.35-1.13 3.52-1.33 5.14-.47.49.26 1.1.07 1.35-.42a.996.996 0 0 0-.42-1.35"/>
</svg>

    );
  }
}
